import makeRequest from '../components/make-request'

document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll(".section-church-notes");
    if (sections) {
        sections.forEach((section) => {
            const dropdowns = section.querySelectorAll(".dropdown-notes");
            const form = section.querySelector(".form");
            const name = form.querySelector(".section-note-name");
            const subname = form.querySelector(".section-note-subname");
            const nameInputs = section.querySelector(".notes-names").querySelectorAll("input");
            const btn = section.querySelector("button");

            dropdowns.forEach((dropdown) => {

                function formatRubles(value) {
                    const number = Number(value);
                    return new Intl.NumberFormat('ru-RU', {
                        maximumFractionDigits: 0
                    }).format(number);
                }

                function attachItemListeners(dropdown) {
                    const main = dropdown.querySelector(".dropdown-notes-main");
                    const items = dropdown.querySelectorAll(".dropdown-notes-item");
                    const input = dropdown.closest('.section-church-notes__selects-box').querySelector('input');

                    items.forEach((item) => {
                        item.addEventListener("click", () => {
                            main.querySelector("h4").textContent = item.getAttribute("data-text");
                            input.value = item.dataset.text;


                            if (main.dataset.type) {
                                main.dataset.type = item.dataset.text;
                                updateSubTypeFields(item.dataset.text);

                                if (item.dataset.color === 'gold') {
                                    name.classList.add("section-church-notes__form-name--gold");
                                    name.classList.remove("section-church-notes__form-name--dark");
                                } else if (item.dataset.color === 'dark') {
                                    name.classList.add("section-church-notes__form-name--dark");
                                    name.classList.remove("section-church-notes__form-name--gold");
                                }
                                name.textContent = item.dataset.text;
                            } else if (main.dataset.subtype) {
                                main.dataset.subtype = item.dataset.text;
                                subname.textContent = item.dataset.text;
                            }

                            updateDonation(main.dataset.subtype, item.dataset.parent);
                        });
                    });
                }

                function updateDropdownFields(dropdown) {
                    const col = dropdown.querySelector(".dropdown-notes-col");

                    dropdown.addEventListener("click", (event) => {
                        event.stopPropagation();
                        if (col) {
                            col.classList.toggle("active");
                        }
                    });

                    document.addEventListener("click", (event) => {
                        if (!dropdown.contains(event.target)) {
                            if (col && col.classList.contains("active")) {
                                col.classList.remove("active");
                            }
                        }
                    });

                    attachItemListeners(dropdown);
                }


                function updateSubTypeFields(type) {
                    const subtypeDropdown = dropdowns[1];
                    const col = subtypeDropdown.querySelector(".section-church-notes__selects-col");
                    const main = subtypeDropdown.querySelector(".dropdown-notes-main");
                    const input = subtypeDropdown.closest('.section-church-notes__selects-box').querySelector('input');

                    const arrayValue = window.notes.find(note => note.type === type);
                    if (!arrayValue || !arrayValue['subtype-repeater']) return;

                    col.innerHTML = "";

                    arrayValue['subtype-repeater'].forEach((value) => {
                        const div = document.createElement("div");
                        div.classList.add("dropdown-notes-item", "section-church-notes__selects-col-item");
                        div.dataset.value = value['subtype-name'];
                        div.dataset.text = value['subtype-name'];
                        div.textContent = value['subtype-name'];
                        div.dataset.parent = type;

                        col.appendChild(div);
                    });

                    const firstSubtype = arrayValue['subtype-repeater'][0]['subtype-name'];
                    main.dataset.subtype = firstSubtype;
                    main.querySelector("h4").textContent = firstSubtype;
                    subname.textContent = firstSubtype;
                    updateDonation(firstSubtype, type);
                    attachItemListeners(subtypeDropdown);
                }

                function updateDonation(item, type) {
                    const donation = section.querySelector("#donation-value");

                    if (type) {
                        const subtypeArray = window.notes.find(note => note.type === type)?.['subtype-repeater'] || [];
                        const matchedSubtype = subtypeArray.find(sub => sub['subtype-name'] === item);

                        if (matchedSubtype) {
                            const subtypeDonation = matchedSubtype['subtype-donation'];
                            const donationType = matchedSubtype['donation-type'];
                            const input = donation.closest(".section-church-notes__donation").querySelector("input");

                            if (donationType === 'per_list') {
                                input.value = Number(subtypeDonation);
                                donation.textContent = `${formatRubles(subtypeDonation)} рублей`;
                            } else if (donationType === 'per_name') {
                                const names = section.querySelectorAll(".notes-names input");
                                let filledCount = 0;

                                names.forEach(input => {
                                    if (input.value.trim() !== "") {
                                        filledCount++;
                                    }
                                });

                                const price = subtypeDonation * filledCount;

                                input.value = Number(price);
                                donation.textContent = `${formatRubles(price)} рублей`;
                            }

                            if (donation) {
                                donation.value = subtypeDonation;
                                donation.dataset.type = donationType;
                            }
                        }
                    }
                }

                function checkInput(inputs, btn) {
                    const isAnyFilled = Array.from(inputs).some(input => input.value.trim() !== "");
                    if (isAnyFilled) {
                        btn.removeAttribute("disabled");
                    } else {
                        btn.setAttribute("disabled", "true");
                    }
                }

                function focusInput(inputs) {
                    inputs.forEach(input => {
                        input.addEventListener("input", () => {
                            const type = section.querySelector('.dropdown-notes-main[data-type]')?.dataset.type;
                            const subtype = section.querySelector('.dropdown-notes-main[data-subtype]')?.dataset.subtype;

                            if (type && subtype) {
                                updateDonation(subtype, type);
                            }

                            checkInput(inputs, btn);
                        });
                    });
                }

                focusInput(nameInputs);

                window.addEventListener("pageshow", () => {
                    checkInput(nameInputs, btn);
                });

                requestAnimationFrame(() => {
                    checkInput(nameInputs, btn);
                });

                updateDropdownFields(dropdown);
            });

            function notesSubmit(event) {
                event.preventDefault()

                let data = new FormData(form)
                data.append('action', 'notes')
                let request = makeRequest(window.ajaxUrl, data, "POST")
                request.then((result) => {
                    switch (result.status) {
                        case 'success':
                            initPay(result)
                            break;
                        case 'not-valid':
                            break;
                    }
                })
            }
            function initPay(result) {
                document.location.href = result.pay_link
            }

            if (btn) {
                btn.addEventListener("click", (event) => {
                    btn.classList.add("loading");
                    notesSubmit(event);
                })
            }
        });
    }
});